// Generic types for the app
export type Maybe<T> = T | undefined;

export enum ModalAction {
  Update = 'update',
  Cancel = 'cancel',
  Add = 'add',
}

export enum Direction {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum ASComponentSize {
  Small = 'ASSmall',
  Medium = 'ASMedium',
  Large = 'ASLarge',
}

export enum ASOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
}

export enum ASDirection {
  Left = 'left',
  Right = 'right',
}

export type ASDimension = { width: number; height: number };

export type ASOrientationT = keyof typeof ASOrientation;
export type ASDirectionT = keyof typeof ASDirection;

type ASPaddingSizeTuple = [ASComponentSize, ASComponentSize];
type ASPaddingSizeTriple = [ASComponentSize, ASComponentSize, ASComponentSize];
type ASPaddingSizeQuad = [ASComponentSize, ASComponentSize, ASComponentSize, ASComponentSize];
export type ASPaddingSize = ASComponentSize | ASPaddingSizeTuple | ASPaddingSizeTriple | ASPaddingSizeQuad;

/* cspell: disable */
export type ASPaddingTopSize = 'ASPDTASSmall' | 'ASPDTASMedium' | 'ASPDTASLarge';
export type ASPaddingRightSize = 'ASPDRASSmall' | 'ASPDRASMedium' | 'ASPDRASLarge';
export type ASPaddingBottomSize = 'ASPDBASSmall' | 'ASPDBASMedium' | 'ASPDBASLarge';
export type ASPaddingLeftSize = 'ASPDLASSmall' | 'ASPDLASMedium' | 'ASPDLASLarge';

export type ASPaddingKeys = ASPaddingTopSize & ASPaddingRightSize & ASPaddingBottomSize & ASPaddingLeftSize;

export type PaddingSizeToClsType = {
  [key in ASPaddingKeys]: string;
};

export interface Dictionary<T> {
  [key: string]: T;
}
